// Translations for Senior Voice Assistant

export const translations = {
  en: {
    // Dashboard
    caregiverDashboard: 'Caregiver Dashboard',
    manageAndMonitor: 'Manage and monitor senior care',
    manageUsers: 'Manage Users',
    seniorView: 'Senior View',
    todaysReminders: "Today's Reminders",
    emergencyContacts: 'Emergency Contacts',
    emergencyLogs: 'Emergency Logs',
    activeModules: 'Active Modules',
    
    // Tabs
    reminders: 'Reminders',
    contacts: 'Contacts',
    emergency: 'Emergency',
    settings: 'Settings',
    
    // Senior Interface
    hello: 'Hello',
    howCanIHelp: 'How can I help you today?',
    tapToSpeak: 'Tap to Speak',
    listening: 'Listening...',
    youSaid: 'You said:',
    response: 'Response:',
    emergencyHelp: 'Emergency Help',
    callContacts: 'Call Contacts',
    prayerTimes: 'Prayer Times',
    todaysSchedule: "Today's Schedule",
    pending: 'pending',
    
    // Reminders
    manageReminders: 'Manage Reminders',
    addReminder: 'Add Reminder',
    createNewReminder: 'Create New Reminder',
    reminderFor: 'Set up a reminder for medication, routines, or appointments',
    title: 'Title',
    description: 'Description',
    type: 'Type',
    date: 'Date',
    time: 'Time',
    repeat: 'Repeat',
    noReminders: 'No reminders yet. Create one to get started.',
    medication: 'Medication',
    routine: 'Routine',
    appointment: 'Appointment',
    noRepeat: 'No Repeat',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    
    // Contacts
    addContact: 'Add Contact',
    addEmergencyContact: 'Add Emergency Contact',
    trustedPerson: 'Add a trusted person to call in case of emergency',
    name: 'Name',
    relationship: 'Relationship',
    phone: 'Phone Number',
    priority: 'Priority',
    priorityNote: 'Lower numbers are called first in emergencies',
    noContacts: 'No emergency contacts yet. Add at least one for safety.',
    
    // Settings
    profileSettings: 'Profile Settings',
    updateProfile: 'Update user profile information',
    language: 'Language',
    location: 'Location',
    religionModule: 'Religious Module',
    saveChanges: 'Save Profile Changes',
    prayerSettings: 'Prayer Settings',
    calculationMethod: 'Calculation Method',
    reminderBefore: 'Reminder Before Prayer (minutes)',
    enableAdhan: 'Enable Adhan Sound',
    playCallToPrayer: 'Play call to prayer notification',
    
    // User Management
    createUserProfile: 'Create User Profile',
    setupProfile: 'Set up a profile for a senior user to get started',
    fullName: 'Full Name',
    age: 'Age',
    city: 'Location (City)',
    timezone: 'Timezone',
    existingUsers: 'Existing Users',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    back: 'Back',
    backToDashboard: 'Back to Dashboard',
  },
  
  de: {
    // Dashboard
    caregiverDashboard: 'Betreuer-Dashboard',
    manageAndMonitor: 'Seniorenpflege verwalten und überwachen',
    manageUsers: 'Benutzer verwalten',
    seniorView: 'Senioren-Ansicht',
    todaysReminders: 'Heutige Erinnerungen',
    emergencyContacts: 'Notfallkontakte',
    emergencyLogs: 'Notfall-Protokoll',
    activeModules: 'Aktive Module',
    
    // Tabs
    reminders: 'Erinnerungen',
    contacts: 'Kontakte',
    emergency: 'Notfall',
    settings: 'Einstellungen',
    
    // Senior Interface
    hello: 'Hallo',
    howCanIHelp: 'Wie kann ich Ihnen heute helfen?',
    tapToSpeak: 'Zum Sprechen tippen',
    listening: 'Ich höre zu...',
    youSaid: 'Sie sagten:',
    response: 'Antwort:',
    emergencyHelp: 'Notfall-Hilfe',
    callContacts: 'Kontakte anrufen',
    prayerTimes: 'Gebetszeiten',
    todaysSchedule: 'Heutiger Zeitplan',
    pending: 'ausstehend',
    
    // Reminders
    manageReminders: 'Erinnerungen verwalten',
    addReminder: 'Erinnerung hinzufügen',
    createNewReminder: 'Neue Erinnerung erstellen',
    reminderFor: 'Erinnerung für Medikamente, Routinen oder Termine einrichten',
    title: 'Titel',
    description: 'Beschreibung',
    type: 'Typ',
    date: 'Datum',
    time: 'Uhrzeit',
    repeat: 'Wiederholen',
    noReminders: 'Noch keine Erinnerungen. Erstellen Sie eine, um loszulegen.',
    medication: 'Medikament',
    routine: 'Routine',
    appointment: 'Termin',
    noRepeat: 'Nicht wiederholen',
    daily: 'Täglich',
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
    
    // Contacts
    addContact: 'Kontakt hinzufügen',
    addEmergencyContact: 'Notfallkontakt hinzufügen',
    trustedPerson: 'Vertrauensperson hinzufügen, die im Notfall angerufen wird',
    name: 'Name',
    relationship: 'Beziehung',
    phone: 'Telefonnummer',
    priority: 'Priorität',
    priorityNote: 'Niedrigere Nummern werden zuerst im Notfall angerufen',
    noContacts: 'Noch keine Notfallkontakte. Fügen Sie mindestens einen für die Sicherheit hinzu.',
    
    // Settings
    profileSettings: 'Profil-Einstellungen',
    updateProfile: 'Benutzer-Profilinformationen aktualisieren',
    language: 'Sprache',
    location: 'Standort',
    religionModule: 'Religions-Modul',
    saveChanges: 'Profil-Änderungen speichern',
    prayerSettings: 'Gebetseinstellungen',
    calculationMethod: 'Berechnungsmethode',
    reminderBefore: 'Erinnerung vor Gebet (Minuten)',
    enableAdhan: 'Adhan-Ton aktivieren',
    playCallToPrayer: 'Gebetsruf-Benachrichtigung abspielen',
    
    // User Management
    createUserProfile: 'Benutzerprofil erstellen',
    setupProfile: 'Profil für einen Senior-Benutzer einrichten, um loszulegen',
    fullName: 'Vollständiger Name',
    age: 'Alter',
    city: 'Standort (Stadt)',
    timezone: 'Zeitzone',
    existingUsers: 'Vorhandene Benutzer',
    
    // Common
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    back: 'Zurück',
    backToDashboard: 'Zurück zum Dashboard',
  },
  
  ar: {
    // Dashboard
    caregiverDashboard: 'لوحة تحكم مقدم الرعاية',
    manageAndMonitor: 'إدارة ومراقبة رعاية كبار السن',
    manageUsers: 'إدارة المستخدمين',
    seniorView: 'عرض كبار السن',
    todaysReminders: 'تذكيرات اليوم',
    emergencyContacts: 'جهات اتصال الطوارئ',
    emergencyLogs: 'سجلات الطوارئ',
    activeModules: 'الوحدات النشطة',
    
    // Tabs
    reminders: 'التذكيرات',
    contacts: 'جهات الاتصال',
    emergency: 'الطوارئ',
    settings: 'الإعدادات',
    
    // Senior Interface
    hello: 'مرحباً',
    howCanIHelp: 'كيف يمكنني مساعدتك اليوم؟',
    tapToSpeak: 'اضغط للتحدث',
    listening: 'أستمع...',
    youSaid: 'قلت:',
    response: 'الرد:',
    emergencyHelp: 'مساعدة طارئة',
    callContacts: 'اتصل بجهات الاتصال',
    prayerTimes: 'أوقات الصلاة',
    todaysSchedule: 'جدول اليوم',
    pending: 'معلق',
  },
  
  tr: {
    // Dashboard
    caregiverDashboard: 'Bakıcı Paneli',
    manageAndMonitor: 'Yaşlı bakımını yönetin ve izleyin',
    manageUsers: 'Kullanıcıları Yönet',
    seniorView: 'Yaşlı Görünümü',
    todaysReminders: 'Bugünün Hatırlatıcıları',
    emergencyContacts: 'Acil Durum Kişileri',
    emergencyLogs: 'Acil Durum Kayıtları',
    activeModules: 'Aktif Modüller',
    
    // Tabs
    reminders: 'Hatırlatıcılar',
    contacts: 'Kişiler',
    emergency: 'Acil Durum',
    settings: 'Ayarlar',
    
    // Senior Interface
    hello: 'Merhaba',
    howCanIHelp: 'Bugün size nasıl yardımcı olabilirim?',
    tapToSpeak: 'Konuşmak için dokunun',
    listening: 'Dinliyorum...',
    youSaid: 'Dediniz ki:',
    response: 'Yanıt:',
    emergencyHelp: 'Acil Yardım',
    callContacts: 'Kişileri Ara',
    prayerTimes: 'Namaz Vakitleri',
    todaysSchedule: 'Bugünün Programı',
    pending: 'beklemede',
    
    // Reminders
    manageReminders: 'Hatırlatıcıları Yönet',
    addReminder: 'Hatırlatıcı Ekle',
    createNewReminder: 'Yeni Hatırlatıcı Oluştur',
    reminderFor: 'İlaç, rutin veya randevular için hatırlatıcı ayarlayın',
    title: 'Başlık',
    description: 'Açıklama',
    type: 'Tür',
    date: 'Tarih',
    time: 'Saat',
    repeat: 'Tekrarla',
    noReminders: 'Henüz hatırlatıcı yok. Başlamak için bir tane oluşturun.',
    medication: 'İlaç',
    routine: 'Rutin',
    appointment: 'Randevu',
    noRepeat: 'Tekrarlama',
    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',
    
    // Contacts
    addContact: 'Kişi Ekle',
    addEmergencyContact: 'Acil Durum Kişisi Ekle',
    trustedPerson: 'Acil durumlarda aranacak güvenilir bir kişi ekleyin',
    name: 'İsim',
    relationship: 'İlişki',
    phone: 'Telefon Numarası',
    priority: 'Öncelik',
    priorityNote: 'Düşük sayılar acil durumlarda önce aranır',
    noContacts: 'Henüz acil durum kişisi yok. Güvenlik için en az bir tane ekleyin.',
    
    // Settings
    profileSettings: 'Profil Ayarları',
    updateProfile: 'Kullanıcı profil bilgilerini güncelleyin',
    language: 'Dil',
    location: 'Konum',
    religionModule: 'Din Modülü',
    saveChanges: 'Profil Değişikliklerini Kaydet',
    prayerSettings: 'Namaz Ayarları',
    calculationMethod: 'Hesaplama Yöntemi',
    reminderBefore: 'Namazdan Önce Hatırlatma (dakika)',
    enableAdhan: 'Ezan Sesini Etkinleştir',
    playCallToPrayer: 'Namaz çağrısı bildirimini çal',
    
    // User Management
    createUserProfile: 'Kullanıcı Profili Oluştur',
    setupProfile: 'Başlamak için yaşlı kullanıcı için profil oluşturun',
    fullName: 'Tam İsim',
    age: 'Yaş',
    city: 'Konum (Şehir)',
    timezone: 'Saat Dilimi',
    existingUsers: 'Mevcut Kullanıcılar',
    
    // Common
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    create: 'Oluştur',
    back: 'Geri',
    backToDashboard: 'Panele Dön',
  }
};

export const getTranslation = (key, language = 'en') => {
  const lang = translations[language] || translations.en;
  return lang[key] || translations.en[key] || key;
};

export const t = getTranslation;
